const SystemHealthItemContent = ({
  children
}: {
  children: React.ReactNode;
}) => <div className="system-health__dropdown-item-content">{children}</div>;

export default SystemHealthItemContent;
